import images from "../../ImageVariables";
import "../SCSS/styles.css";
export default function Landscape() {
  return (
    <div className="mobile-landscape-main-container">
      <div className="mobile-landscape-inner-container">
        <div className="mobile-landscape-inner-container-image">
          <img
            src={images.landscape}
            alt="landscape_img"
            style={{ height: "35%", width: "25%" }}
          />
        </div>
        <div className="mobile-landscape-inner-container-content">
          <div className="mobile-landscape-inner-container-desc">
            Landscape Mode is currently unavailable.
          </div>
          <div className="mobile-landscape-inner-container-desc-content">
            Kindly use the tool in portrait mode.
          </div>
        </div>
      </div>
    </div>
  );
}
